module.exports = __webpack_public_path__ + "img/connexion.0ade76ca.svg";